/** Status-Badges mit fester Farbe je Wert (Farben in styles.css, Klasse st-<wert>). */
import type { AuftragStatus, Route, SendungStatus, RetoureStatus } from '@storeos/contracts';
import { AUFTRAG_TEXT, RETOURE_TEXT, ROUTE_TEXT, SENDUNG_TEXT } from './format';

export function SendungBadge({ status, gross }: { status: SendungStatus; gross?: boolean }) {
  return <span className={`st st-${status}${gross ? ' gross' : ''}`} data-status={status}>{SENDUNG_TEXT[status] ?? status}</span>;
}
export function AuftragBadge({ status }: { status: AuftragStatus }) {
  return <span className={`st sta-${status}`} data-status={status}>{AUFTRAG_TEXT[status] ?? status}</span>;
}
export function RouteBadge({ route }: { route: Route }) {
  return <span className={`route route-${route}`}>{ROUTE_TEXT[route] ?? route}</span>;
}
export function RetoureBadge({ status }: { status: RetoureStatus }) {
  return <span className={`st str-${status}`} data-status={status}>{RETOURE_TEXT[status] ?? status}</span>;
}
export function TestBadge({ test }: { test: boolean }) {
  return test ? <span className="badge env-test" title="Testbeleg (STOREOS_ENV ≠ live)">TEST</span> : <span className="badge env-live">LIVE</span>;
}
